<nav class="admin-nav">
    <!-- Dashboard first: admins and sales. -->
    @if (canAccessOrders) {
        <!-- exact match so Overview doesn't stay active on /dashboard/orders -->
        <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Overview</a>
        <a routerLink="/dashboard/orders" routerLinkActive="active">Orders</a>
    }
    <!-- Messages is admin-only: canAccessOrders covers the overview and orders,
         not the contact inbox. -->
    @if (isAdmin) {
        <a routerLink="/dashboard/messages" routerLinkActive="active">Messages</a>

        <!-- Administration after it. -->
        <a routerLink="/gateways" routerLinkActive="active">Admin gateways</a>
        <a routerLink="/users" routerLinkActive="active">Users</a>
        <a routerLink="/files" routerLinkActive="active">Files</a>
        <a routerLink="/categories" routerLinkActive="active">Categories</a>
        <a routerLink="/equipment-management" routerLinkActive="active">Equipment</a>
        <a routerLink="/projects-management" routerLinkActive="active">Projects</a>
    }

    <!-- Local file-portal user: their own files, never Gateways — matches the
         legacy usr/main.php menu. -->
    @if (isFilePortalUser) {
        <a routerLink="/my-files" routerLinkActive="active">Files</a>
    }

    <!-- Cloud gateway customer: Gateways, never Files — matches the legacy
         usr/main_gw.php menu. -->
    @if (isCloudCustomer) {
        <a routerLink="/gateways" routerLinkActive="active">Gateways</a>
    }

    <!-- Shared by every role: the page only requires a session, and a cloud
         customer gets the password-only version of it. -->
    @if (isLoggedIn) {
        <a routerLink="/account" routerLinkActive="active">Account Details</a>
    }
</nav>
